import React from "react"
import GradiLink from "./gradi-link"

const Button = ({
  banner,
  bolder,
  children,
  action = false,
  sub = false,
  className = "",
  ...other
}) => {
  let typeClass = ""
  if (banner) {
    typeClass = `${typeClass} border-2 md:text-md `
  } else if (bolder) {
    typeClass = `${typeClass} font-bold border-2 text-md `
  } else {
    typeClass = `${typeClass} border md:text-md font-normal text-sm `
  }

  const spacing = action
    ? `py-3 ${sub ? "" : "max-w-xs"} hover:bg-blackish hover:text-warm-gray hover:border-blackish px-5`
    : "px-10 py-3 hover:border-2 "

  return (
    <GradiLink
      {...other}
      className={`transition ease-out transition-color whitespace-nowrap round-button rounded rounded-full uppercase text-center cursor-pointer ${className} ${typeClass} ${spacing}`}
      underline={false}
    >
      {children}
    </GradiLink>
  )
}

export default Button
